module.exports = __webpack_public_path__ + "img/wizard-loader-4.0ec55c5f.png";